(() => {
 const preference = matchMedia('(prefers-reduced-motion: reduce)');
 let observer, frame = 0;
 let media = [];
 const update = () => {
  frame = 0;
  if (preference.matches) return;
  media.forEach(el => {
   const box = el.closest("section").getBoundingClientRect();
   if (box.bottom < 0 || box.top > innerHeight * .88) return;
   const range = innerWidth < 750 ? 36 : 72;
   const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - box.top - box.height / 2) / (innerHeight / 2 + box.height / 2)));
   el.style.setProperty('--ct-y', `${(progress * range).toFixed(2)}px`);
   el.style.setProperty('--ct-scale', (1 + (progress + 1) * .025).toFixed(3));
  });
 };
 const schedule = () => { if (!preference.matches && !frame) frame = requestAnimationFrame(update); };
 const init = () => {
  if (observer) observer.disconnect();
  media = [...document.querySelectorAll('[data-ct-parallax]')];
  document.querySelectorAll('.ct-pending').forEach(el => el.classList.remove('ct-pending'));
  media.forEach(el => { el.style.removeProperty('--ct-y'); el.style.removeProperty('--ct-scale'); });
  if (preference.matches) return;
  update();
  if (!('IntersectionObserver' in window)) return;
  observer = new IntersectionObserver(entries => entries.forEach(entry => {
   if (entry.target.classList.contains('ct-hero')) entry.target.classList.toggle('ct-inview', entry.isIntersecting);
   else if (entry.isIntersecting) {
    entry.target.classList.remove('ct-pending');
    entry.target.classList.add('ct-inview');
    observer.unobserve(entry.target);
   }
  }), {threshold: .12});
  document.querySelectorAll('.ct-reveal').forEach(el => {
   if (el.getBoundingClientRect().top > innerHeight * .88) el.classList.add('ct-pending');
   observer.observe(el);
  });
  document.querySelectorAll('.ct-hero').forEach(el => observer.observe(el));
  schedule();
 };
 addEventListener('scroll', schedule, {passive: true});
 addEventListener('resize', schedule, {passive: true});
 if (preference.addEventListener) preference.addEventListener('change', init);
 else preference.addListener(init);
 document.addEventListener('shopify:section:load', init);
 document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
 document.addEventListener('shopify:section:select', event => event.target.querySelectorAll('.ct-pending').forEach(el => el.classList.remove('ct-pending')));
 document.addEventListener('change', event => {
  if (event.target.matches('[data-variant-picker]')) location.assign(event.target.value);
 });
 init();
})();
(() => {
 const controllers = new Map();
 const init = () => {
  document.querySelectorAll('[data-ah-reviews]').forEach(root => {
   if (controllers.has(root)) return;
   const slides = [...root.querySelectorAll('[data-review-slide]')];
   const dots = [...root.querySelectorAll('[data-review-index]')];
   const toggle = root.querySelector('[data-review-toggle]');
   const track = root.querySelector('.ah-review-track');
   const reduce = matchMedia('(prefers-reduced-motion: reduce)');
   let index = 0, timer, paused = reduce.matches, startX = 0, hover = false;
   const show = next => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== index; });
    dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
   };
   const schedule = () => {
    clearInterval(timer);
    if (!paused && !hover && !document.hidden && slides.length > 1 && !root.contains(document.activeElement)) timer = setInterval(() => show(index + 1), Number(root.dataset.interval));
   };
   const updateToggle = () => { toggle.textContent = paused ? '▷' : 'Ⅱ'; toggle.setAttribute('aria-label', paused ? toggle.dataset.play : toggle.dataset.pause); };
   root.querySelector('[data-review-prev]').addEventListener('click', () => { show(index - 1); schedule(); });
   root.querySelector('[data-review-next]').addEventListener('click', () => { show(index + 1); schedule(); });
   toggle.addEventListener('click', () => { paused = !paused; updateToggle(); schedule(); });
   dots.forEach(dot => dot.addEventListener('click', () => { show(Number(dot.dataset.reviewIndex)); schedule(); }));
   root.addEventListener('mouseenter', () => { hover = true; schedule(); });
   root.addEventListener('mouseleave', () => { hover = false; schedule(); });
   root.addEventListener('focusin', schedule);
   root.addEventListener('focusout', () => setTimeout(schedule, 0));
   track.addEventListener('touchstart', event => { startX = event.changedTouches[0].clientX; clearInterval(timer); }, {passive:true});
   track.addEventListener('touchend', event => { const delta = event.changedTouches[0].clientX - startX; if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1)); schedule(); }, {passive:true});
   const visibility = () => schedule();
   document.addEventListener('visibilitychange', visibility);
   const motion = () => { if (reduce.matches) paused = true; updateToggle(); schedule(); };
   reduce.addEventListener('change', motion);
   if (slides.length < 2) { root.querySelector('.ah-review-controls').hidden = true; root.querySelector('.ah-review-dots').hidden = true; }
   updateToggle(); schedule();
   controllers.set(root, { show, destroy: () => { clearInterval(timer); document.removeEventListener('visibilitychange',visibility); reduce.removeEventListener('change',motion); } });
  });
 };
 document.addEventListener('change', event => {
  if (!event.target.matches('input[data-ah-price]')) return;
  const root = event.target.closest('[data-ah-product]');
  root.querySelectorAll('.ah-option').forEach(el => el.classList.toggle('is-selected', el.contains(event.target)));
  root.querySelector('[data-ah-price-display]').textContent = event.target.dataset.ahPrice;
  const button = root.querySelector('[data-ah-submit]');
  const available = event.target.dataset.ahAvailable === 'true';
  button.disabled = !available; button.textContent = available ? button.dataset.add : button.dataset.sold;
  const photo = root.querySelector('[data-ah-photo]');
  const duo = event.target.dataset.ahDuo === 'true';
  photo.classList.toggle('ah-photo-duo', duo);
  photo.querySelector('[data-ah-single]').hidden = duo;
  photo.querySelector('[data-ah-duo-visual]').hidden = !duo;
  const source = event.target.dataset.ahImage || event.target.dataset.ahAsset;
  if (!duo && source) { const image = photo.querySelector('[data-ah-single] img'); image.removeAttribute('srcset'); image.src = source; }

 });
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('shopify:section:unload',event => { controllers.forEach((controller, root) => { if (event.target.contains(root)) { controller.destroy(); controllers.delete(root); } }); });
 document.addEventListener('shopify:block:select',event => { const root = event.target.closest('[data-ah-reviews]'); if (!root) return; const slide = event.target.closest('[data-review-slide]'); const index = [...root.querySelectorAll('[data-review-slide]')].indexOf(slide); if (index >= 0) controllers.get(root)?.show(index); });
 init();
})();
